module.exports = __webpack_public_path__ + "img/Comp & Ben.931204b3.png";